import { FC, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { RouteComponentProps, useRouteMatch } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { doGetEvaluations, doCreateEvaluation } from '../../../store/evaluation.slice';
import { doGetItems, doGetFirstItems } from '../../../store/criteria.slice';
import { doRemoveAuth } from '../../../store/auth.slice';
import { RootState } from '../../../store/rootReducer';
import qs from 'qs';
import _ from 'lodash';
import { useSnackbar } from 'notistack';
import { Button as AntButton, Modal, Select, Table, TableColumnsType } from 'antd';

import Loader from '../../../components/Loader';
import Header from '../../../components/layout/Header';
import Footer from '../../../components/layout/Footer';
import { successVariant, warningVariant, errorVariant, infoVariant } from '../../../lib/barVariant';
import Button from '../../../components/Button';
import Radio from '../../../components/Radio';
import Checkbox from '../../../components/Checkbox';
import Pagination from '../../../components/Pagination';
import config from '../../../lib/config';
import { Descriptions } from 'antd';
import useAuth from '../../../hooks/useAuth';

interface IMatch {
  id: string;
}

const ProgramStepCreate: FC<RouteComponentProps> = ({ history, location }) => {
  const { writeAuthYn } = useAuth();
  const { t } = useTranslation();
  const { enqueueSnackbar } = useSnackbar();
  const { commonCodes } = useSelector((state: RootState) => state.commonCode);
  // GR0001 = 평가 구분
  const GR0001 = commonCodes.find(item => item.commonCode === 'GR0001')?.detailCode;

  const match = useRouteMatch<IMatch>();
  const courseCode = Number(match.params.id);
  const query = qs.parse(location.search, { ignoreQueryPrefix: true });
  const dispatch = useDispatch();

  const { isLoading } = useSelector((state: RootState) => state.evaluation);
  const { items, isLoading: itemLoading } = useSelector((state: RootState) => state.criteria);

  const [level, setLevel] = useState('');
  const [step, setStep] = useState('');

  const [selectActivityVisible, setSelectActivityVisible] = useState(false);
  const [itemData, setItemData] = useState<any>([]);
  const [page, setPage] = useState(1);
  // 구분
  const [type, setType] = useState<any>(null);
  const [typeList, setTypeList] = useState<any>(null);
  // 대분류
  const [category, setCategory] = useState<any>(null);
  const [categoryList, setCategoryList] = useState<any>(null);
  // 검색용 키워드
  const [activity, setActivity] = useState<any>(null);
  // 선택한 activities
  const [activities, setActivities] = useState<any>([]);
  const [select, setSelect] = useState<any>([]);
  const [isSelectAll, setIsSelectAll] = useState<any>(false);

  const [useYn, setUseYn] = useState('Y');
  const all = { label: t('common.text.all'), value: 'all' };

  useEffect(() => {
    if (GR0001) {
      const list: any = [all];
      GR0001.forEach((item: any) => {
        list.push({ label: item.korName, value: item.detailCode });
      });
      console.log('list', list);
      setTypeList(list);
    }
  }, [commonCodes]);

  useEffect(() => {
    setItemData(items);
  }, [items]);

  useEffect(() => {
    // query to state
    if (query.level) setLevel(String(query.level));
    if (query.step) setStep(String(query.step));
  }, [location]);

  useEffect(() => {
    getFirstItems();
    getItems();
  }, []);

  const getFirstItems = async () => {
    const res = await dispatch(doGetFirstItems());

    switch (res?.status) {
      case 200:
        {
          const data = res?.data?.data;
          if (data) {
            const list: any = [all];
            data.forEach((item: any) => {
              list.push({ label: item.itemName, value: item.itemCode });
            });
            setCategoryList(list);
          }
        }
        break;
      case 401:
        dispatch(doRemoveAuth());
        break;
      case 403:
        enqueueSnackbar(t('common.message.forbidden'), warningVariant);
        history.push('/');
        break;
      default:
        enqueueSnackbar(res?.data?.data || t('common.message.error'), errorVariant);
    }
  }

  const getItems = async () => {
    const res = await dispatch(doGetItems());

    switch (res?.status) {
      case 200:
        break;
      case 401:
        dispatch(doRemoveAuth());
        break;
      case 403:
        enqueueSnackbar(t('common.message.forbidden'), warningVariant);
        history.push('/');
        break;
      default:
        enqueueSnackbar(res?.data?.data || t('common.message.error'), errorVariant);
    }
  }

  const onSearch = () => {
    let data: any = _.cloneDeep(items);

    if (type && type.value !== 'all') {
      // eslint-disable-next-line eqeqeq
      data = data.filter((item: any) => item.brnCode == type.value);
    }
    if (category && category.value !== 'all') {
      // eslint-disable-next-line eqeqeq
      data = data.filter((item: any) => item.firstItemCode == category.value);
    }
    if (activity) {
      data = data.filter((item: any) => item.thirdItemName.indexOf(activity) !== -1);
    }

    setItemData(data);
  }

  const onSubmit = async () => {
    if (activities.length === 0) {
      return enqueueSnackbar(t('program.step.1'), infoVariant);
    }

    const req = {
      evaluationItemCode: activities,
      useYn
    }

    const res = await dispatch(doCreateEvaluation(courseCode, req));

    switch (res?.status) {
      case 200:
        dispatch(doGetEvaluations(courseCode));
        enqueueSnackbar(t('program.step.2'), successVariant);
        history.push(`/program/step`);
        break;
      case 401:
        dispatch(doRemoveAuth());
        break;
      case 403:
        enqueueSnackbar(t('common.message.forbidden'), warningVariant);
        history.push('/');
        break;
      default:
        enqueueSnackbar(res?.data?.data || t('common.message.error'), errorVariant);
    }
  }

  const onSetSelect = (id: any) => {
    if (select.includes(id)) {
      setSelect(select.filter((item: string) => item !== id));
      setIsSelectAll(false);
    } else {
      setSelect([...select, id]);
    }
  }

  const onSelectAll = () => {
    if (isSelectAll) {
      setSelect([]);
      setIsSelectAll(false);
    } else {
      setSelect(itemData?.map((item: any) => item.thirdItemCode));
      setIsSelectAll(true);
    }
  }

  const columns: TableColumnsType<any> = [
    {
      title: t('program.step.3'),
      dataIndex: 'brnCode',
      key: 'brnCode',
      align: 'center',
      sorter: (a, b) => a.itemName?.localeCompare(b.itemName),
      render: (value: string) => {
        const item = typeList?.find((item: any) => item.value === value);
        return item?.label || value;
      }
    },
    {
      title: t('program.step.4'),
      dataIndex: 'firstItemName',
      key: 'firstItemName',
      align: 'center',
      sorter: (a, b) => a.firstItemName?.localeCompare(b.firstItemName),
    },
    {
      title: t('program.step.5'),
      dataIndex: 'secondItemName',
      key: 'secondItemName',
      align: 'center',
      sorter: (a, b) => a.secondItemName?.localeCompare(b.secondItemName),
    },
    {
      title: 'Activity',
      dataIndex: 'thirdItemName',
      key: 'thirdItemName',
      align: 'center',
      sorter: (a, b) => a.thirdItemName?.localeCompare(b.thirdItemName),
    },
    {
      title: t('program.step.6'),
      dataIndex: 'typeName',
      key: 'typeName',
      align: 'center',
      sorter: (a, b) => a.typeName?.localeCompare(b.typeName),
    },
    {
      title: (
        <>
          <Checkbox
            checked={isSelectAll}
            onChange={onSelectAll}
            text=""
          />
        </>
      ),
      dataIndex: 'thirdItemCode',
      key: 'thirdItemCode',
      align: 'center',
      render: (value: string) => {
        let checked = false;
        if (select.includes(value)) checked = true;

        return (
          <div className="text-center">
            <Checkbox
              checked={checked}
              onChange={() => onSetSelect(value)}
              text=""
            />
          </div>
        )
      }
    }
  ];

  return (
    <div className="content-wrapper">
      {isLoading || itemLoading ? <Loader /> : null}
      <Header
        parentMenu={t('common.menu.program')}
        currentMenu={t('program.step.7')}
      />
        <div className="main">
          <Descriptions bordered size="small" column={1}>
            <Descriptions.Item label={t('program.step.8')}>
              {level}
            </Descriptions.Item>
            <Descriptions.Item label={t('program.step.9')}>
              {step}
            </Descriptions.Item>
            <Descriptions.Item label={t('program.step.10')}>
              <div className="flex">
                <div>
                  <Button
                    className="btn btn-sm btn-success btn-w100p"
                    onClick={() => {
                      setSelect(activities);
                      setSelectActivityVisible(true);
                    }}
                    text={t('student.student.placeholder6')}
                  />
                </div>
                <div className="ml-2">
                  {
                    activities?.length > 0
                      ? `(${activities.length}${t('program.step.11')})`
                      : t('program.step.12')
                  }
                </div>
              </div>              
            </Descriptions.Item>
            <Descriptions.Item label={t('program.step.13')}>
              <div className="radio-wrapper">
                <Radio
                  checked={useYn === 'Y'}
                  onChange={() => setUseYn('Y')}
                  text={t('common.option.yes')}
                />
                <Radio
                  checked={useYn === 'N'}
                  onChange={() => setUseYn('N')}
                  text={t('common.option.no')}
                />
              </div>
            </Descriptions.Item>
          </Descriptions>

          <div className="row mt-4">
            <div className="col-12 text-center">
              <Button
                onClick={onSubmit}
                className="btn btn-sm btn-primary btn-w100p mr-1"
                text={t('common.button.save')}
                writeAuthYn={writeAuthYn}
              />
              <Button
                onClick={() => history.push(`/program/step`)}
                className="btn btn-sm btn-secondary btn-w100p"
                text={t('common.button.cancel')}
              />
            </div>
          </div>
        </div>
      <Footer />

      {/* 평가항목 선택 모달 */}
      <Modal
        title={`${t('program.step.14')} - ${step}`}
        visible={selectActivityVisible}
        onCancel={() => {
          setSelect([]);
          setSelectActivityVisible(false);          
        }}
        width={700}
        footer={[
          <div className='comm-btn__area justify-content-center'>
            <AntButton
              key="submit"
              className='btn-basic pink'
              onClick={() => {
                setActivities(select);
                setSelectActivityVisible(false);
              }}
            >
              {t('common.button.save')}
            </AntButton>
            <AntButton
              key="cancel"
              className='btn-basic gray'
              onClick={() => {
                setSelect([]);
                setSelectActivityVisible(false);
              }}
            >
              {t('common.button.cancel')}
            </AntButton>
          </div>
        ]}
      >
        <div className="flex flex-justify-end mb-2">
          <div className="w-150p mr-1">
            <Select
              className="w-100"
              placeholder={t('program.step.3')}
              value={type}
              onChange={value => setType(value)}
            >
              {
                typeList?.map((item: any) => {
                  return (
                    <Select.Option
                      key={item.value}
                      value={item.value}
                    >
                      {item.label}
                    </Select.Option>
                  )
                })
              }
            </Select>
          </div>
          <div className="w-150p mr-1">
            <Select
              className="w-100"
              placeholder={t('program.step.4')}
              value={category}
              onChange={value => setCategory(value)}
            >
              {
                categoryList?.map((item: any) => {
                  return (
                    <Select.Option
                      key={item.value}
                      value={item.value}
                    >
                      {item.label}
                    </Select.Option>
                  )
                })
              }
            </Select>
          </div>
          <div className="mr-1">
            <input
              type="text"
              className="form-control input-text"
              placeholder="Activity"
              value={activity}
              onChange={e => setActivity(e.target.value)}
              onKeyPress={e => { if (e.key === 'Enter') onSearch() }}
            />
          </div>
          <Button
            className="btn btn-secondary btn-w100p"
            onClick={onSearch}
            text={t('common.button.search')}
          />
        </div>
        <div>
          <Table
            columns={columns}
            dataSource={itemData || undefined}
            pagination={{
              current: page,
              pageSize: config.miniPageSize
            }}
          />
        </div>
        <div>
          <Pagination
            count={itemData?.length || 0}
            page={page}
            setPage={setPage}
            mini
          />
        </div>
      </Modal>
    </div>
  )
}

export default ProgramStepCreate;
